import { useApolloClient, useMutation } from '@vue/apollo-composable'
import { notification } from 'src/core/hooks/notifications'
import { i18nObject } from 'boot/i18n'
import takePartTournament from 'src/apollo/mutations/takePartTournament.gql'
import competitionCancel from 'src/apollo/mutations/competitionCancel.gql'
import competitions from 'src/apollo/fragments/competitions.gql'

export function useAcceptCompetition(competition, options) {
  const { resolveClient } = useApolloClient()
  const client = resolveClient()

  const id = competition.id
  const variables = {
    id: competition.objectId,
  }
  if (options?.dogeWallet) {
    variables.dogeWallet = options.dogeWallet
  }
  return client
    .mutate({
      mutation: takePartTournament,
      variables,
      update(store, { data }) {
        if (data?.competitionEnter?.result) {
          localStorage.removeItem('joinedTournament')
          store.writeFragment({
            id: `CompetitionType:${id}`,
            fragment: competitions,
            data: {
              __typename: 'CompetitionType',
              score: {
                __typename: 'CompetitorSelfType',
                active: true,
              },
            },
          })
        }
      },
    })
    .then(({ data }) => {
      notification({ type: 'success', text: i18nObject.global.t('successEnterTournament') })
      return data?.competitionEnter?.result
    })
    .catch(console.error)
}

export function useDeclineCompetition(competition) {
  const { mutate } = useMutation(competitionCancel, {
    variables: {
      id: competition.objectId,
    },
  })

  mutate().catch(console.error)
}
